import React from 'react'

export const PageNotFound404 = () => {
  return (
    <div>PageNotFound404</div>
  )
}
